import React, { useState } from "react";
import toList from "../utils/ComponentUtil";
import CustomAccordion from "../utils/CustomAccordion";
import UnorderedList from "../utils/UnorderedList";
import Time from "../../images/time.png";

function JobTemplate({ contents, title, compensation, contentToEditToday, component, editContent }) {
    const [jobContents, setJobContents] = useState(contents);

    return (
        <div className="job-details-wrp">
            <UnorderedList title={title} compensation={compensation} />
            <div className="available-content-wrp">
                <div className="job-title">{title}</div>
                <div className="avaialble-content">Today's available content to Edit: <span>{contentToEditToday}</span></div>
            </div>
            <div className="today-contents-wrp">
                <CustomAccordion accordians={toList(jobContents, undefined, (item, i) => {
                    return {
                        summary: <div className='accordian-summary'>
                            <div className="summary-wrp">
                                <div>{item.name}
                                <div className="additional-details" >
                                    {item?.metrics?.words && <div className="detail-wrp">Total Words : <span className="unit">{item?.metrics?.words}</span></div>}
                                    {item?.metrics?.time && <div className="detail-wrp" >
                                        <img className="time" src={Time}  alt="time" />
                                        <div className="detail" >Avg Reading time : <span className="unit">{item?.metrics?.time}</span></div>
                                    </div>}
                                </div>
                                </div>
                                <div className={"status " + item.status}>{item.status}</div>
                            </div>
                        </div>,
                        details: <div className='accordian-details'>
                            {React.createElement(component, {
                                item: item, editContent: editContent,
                                onSave: (c) => {
                                    const temp = [...jobContents];
                                    temp[i].content = c;
                                    setJobContents(temp);
                                }
                            })}
                        </div>
                    }
                })}></CustomAccordion>
            </div>
        </div>
    );
};
export default JobTemplate;
